export default "__VITE_ASSET__C0q$qlcN__"